import { eventManager } from '~/utils/behavior/applicationEvents/event-manager';

export default function ({ app, store }) {
  app.router.beforeEach((to, from, next) => {
    // Reset scroll tracking on page change
    store.dispatch('gtmEvents/resetScrollTrigger');
    next();
  });

  app.router.afterEach((to, from) => {
    eventManager.raisePageViewEvent(to, from?.fullPath);
  });
}
